import { render, staticRenderFns } from "./TitleCoverSlide.vue?vue&type=template&id=4fb844bc&scoped=true&"
import script from "./TitleCoverSlide.vue?vue&type=script&lang=js&"
export * from "./TitleCoverSlide.vue?vue&type=script&lang=js&"
import style0 from "./TitleCoverSlide.vue?vue&type=style&index=0&id=4fb844bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb844bc",
  null
  
)

export default component.exports